import { makeAutoObservable, runInAction } from 'mobx';
import { apiClient } from '../api/apiclient';
import { academyStore } from './AcademyStore';
export class AssessmentReportStore {
    constructor() {
        this.reports = [];
        this.loading = false;
        this.error = null;
        this.selectedReport = null;
        this.isDialogOpen = false;
        this.isEditing = false;
        this.preselectedPlayerId = null;
        makeAutoObservable(this);
    }
    // Actions
    async fetchReports(academyId, filters) {
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.getAssessmentReportsByAcademyId(academyId, filters);
            if (response.success) {
                runInAction(() => {
                    this.reports = response.data;
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to fetch assessment reports';
                this.loading = false;
            });
        }
    }
    async createReport(reportData) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.createAssessmentReport(academyStore.currentAcademy.id, reportData);
            if (response.success) {
                runInAction(() => {
                    this.reports.unshift(response.data);
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to create assessment report';
                this.loading = false;
            });
            throw error;
        }
    }
    async updateReport(id, reportData) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.updateAssessmentReport(academyStore.currentAcademy.id, id, reportData);
            if (response.success) {
                runInAction(() => {
                    const index = this.reports.findIndex(report => report.id === id);
                    if (index !== -1) {
                        this.reports[index] = response.data;
                    }
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to update assessment report';
                this.loading = false;
            });
            throw error;
        }
    }
    async deleteReport(id) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.deleteAssessmentReport(academyStore.currentAcademy.id, id);
            if (response.success) {
                runInAction(() => {
                    this.reports = this.reports.filter(report => report.id !== id);
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to delete assessment report';
                this.loading = false;
            });
            throw error;
        }
    }
    // Dialog actions
    openCreateDialog(playerId) {
        this.selectedReport = null;
        this.isEditing = false;
        this.preselectedPlayerId = playerId || null;
        this.isDialogOpen = true;
    }
    openEditDialog(report) {
        this.selectedReport = report;
        this.isEditing = true;
        this.isDialogOpen = true;
    }
    closeDialog() {
        this.isDialogOpen = false;
        this.selectedReport = null;
        this.isEditing = false;
        this.preselectedPlayerId = null;
    }
    // Computed
    get hasReports() {
        return this.reports.length > 0;
    }
    get isLoading() {
        return this.loading;
    }
    get hasError() {
        return this.error !== null;
    }
}
export const assessmentReportStore = new AssessmentReportStore();
